import React from 'react'
import styles from './footerLogos.module.scss'
import PropTypes from 'prop-types'

const FooterLogos = ({ logos = [] }) => {
  return (
    <div className={styles.footerLogos}>
      {logos.map((logo, index) => (
        <img src={logo.src} alt={logo.alt} key={index} />
      ))}
    </div>
  )
}

FooterLogos.propTypes = {
  logos: PropTypes.array,
}

export { FooterLogos }
